export const WINDOWS_IMAGES_MAP = [
  {
    number: 0,
    url: 'assets/icons/windows-count/window-default.svg',
  },
  {
    number: 1,
    url: 'assets/icons/windows-count/window-1.svg',
  },
  {
    number: 2,
    url: 'assets/icons/windows-count/window-2.svg',
  },
  {
    number: 3,
    url: 'assets/icons/windows-count/window-3.svg',
  },
  {
    number: 4,
    url: 'assets/icons/windows-count/window-4.svg',
  },
  {
    number: 5,
    url: 'assets/icons/windows-count/window-5.svg',
  },
  {
    number: 6,
    url: 'assets/icons/windows-count/window-6.svg',
  },
  {
    number: 7,
    url: 'assets/icons/windows-count/window-7.svg',
  },
  {
    number: 8,
    url: 'assets/icons/windows-count/window-8.svg',
  },
  {
    number: 9,
    url: 'assets/icons/windows-count/window-9.svg',
  },
  {
    number: 10,
    url: 'assets/icons/windows-count/window-10.svg',
  },
  {
    number: 11,
    url: 'assets/icons/windows-count/window-11.svg',
  },
  {
    number: 12,
    url: 'assets/icons/windows-count/window-12.svg',
  },
  {
    number: 13,
    url: 'assets/icons/windows-count/window-13.svg',
  },
];
